import { atomWithReset } from 'jotai/utils'
import { ServerSentNotification } from '../../../model/Notification'

export const editNotificationPanelAtom = atomWithReset<ServerSentNotification | null>(null)
